module.exports = __webpack_public_path__ + "img/image29.10dce230.png";